import { Link } from "react-router-dom";
import { FOOTER } from "./content";
import { scrollToId } from "./utils";

export const HireFooter = () => (
    <footer data-testid="hire-footer" className="border-t border-hire-line bg-white">
        <div className="container-page py-14 md:py-16 grid md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
                <p className="flex items-center gap-2.5 font-bold text-hire-ink text-[17px]">
                    <span className="h-7 w-7 rounded-lg bg-brand-blue text-white grid place-items-center text-xs font-extrabold">AV</span>
                    {FOOTER.brand}
                </p>
                <p className="mt-4 text-sm text-hire-muted leading-relaxed max-w-xs">{FOOTER.tagline}</p>
            </div>
            <div className="md:col-span-3">
                <p className="text-xs font-semibold tracking-[0.12em] uppercase text-hire-muted">Explore</p>
                <ul className="mt-4 space-y-2.5">
                    {FOOTER.nav.map((l) => (
                        <li key={l.id}>
                            <button
                                type="button"
                                data-testid={`footer-link-${l.id}`}
                                onClick={() => scrollToId(l.id)}
                                className="text-sm text-hire-ink/80 hover:text-brand-blue transition-colors"
                            >
                                {l.label}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="md:col-span-2">
                <p className="text-xs font-semibold tracking-[0.12em] uppercase text-hire-muted">Contact</p>
                <ul className="mt-4 space-y-2.5">
                    {FOOTER.contact.map((c) => (
                        <li key={c.key}>
                            <a
                                href={c.href}
                                target={c.key === "linkedin" ? "_blank" : undefined}
                                rel={c.key === "linkedin" ? "noopener noreferrer" : undefined}
                                data-testid={`footer-contact-${c.key}`}
                                className="text-sm text-hire-ink/80 hover:text-brand-blue transition-colors break-all"
                            >
                                {c.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="md:col-span-2">
                <p className="text-xs font-semibold tracking-[0.12em] uppercase text-hire-muted">Legal</p>
                <ul className="mt-4 space-y-2.5">
                    {FOOTER.legal.map((l) => (
                        <li key={l.href}>
                            <Link to={l.href} data-testid={`footer-legal-${l.href.slice(1)}`} className="text-sm text-hire-ink/80 hover:text-brand-blue transition-colors">
                                {l.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
        <div className="border-t border-hire-line">
            <div className="container-page py-5 text-xs text-hire-muted">
                © {new Date().getFullYear()} {FOOTER.brand}. All rights reserved.
            </div>
        </div>
    </footer>
);

export default HireFooter;
